import React from 'react'
import axios from 'axios';
import {toast} from "react-toastify";
import Echo from 'laravel-echo';

window.io = require('socket.io-client');
class Comment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputComment: '',
            comments: this.props.comments,
            chatBlockShow: this.props.chatBlockShow
        }
        this.key = 'YUIKjuiKJIolkqUiWFDIE5LALyuiolSDwsDXCvBWzMq2gwWBvJcS8kl7RTYuJHTyuj';
    }

    setComment = (event) => {
        this.setState({inputComment: event.target.value});
    }

    submitComment = (event) => {

        let inputComment = this.state.inputComment;
        if (inputComment.length > 0) {
            axios({
                method: 'post',
                url: `${localStorage.apiHost}/save-comment`,
                headers: {
                    'key': this.key,
                    'access-token': localStorage.token
                },
                data: {
                    'program-id': localStorage.programId,
                    'comment': inputComment
                }
            }).then(response => {
                
                if (response.data.status === 200) {

                    toast.success(response.data.message);

                    this.setState({inputComment: ''});

                } else {

                    toast.error(response.data.message);

                }
            });
        }

        event.preventDefault();
    }
    render() {
        return (
            <div className={`${localStorage.userType === 'boardMember'?"bm-chatbox col-lg-12 col-md-12":"col-lg-12 col-md-12" }`}>   
                <div className={`${this.props.voiceBlockShow === 1 && localStorage.userType === "Shareholder" ?"btrc-chatbox":"chatbox" }`}>
                    <div id="chatbox" className="chatbox-header p0" style={{background:localStorage.commentHeaderBgColor}}>
                        <h3 style={{background:localStorage.commentHeaderBgColor, color:localStorage.commentHeaderTextColor, textAlign: 'center'}}>Questions/Comments</h3>
                    </div>

                    <div>

                        {this.state.chatBlockShow === '1' ? 

                            <div>
                                {localStorage.comment_view_with_login == '1'
                                ?
                                    <>
                                    {this.props.isLogin == 'true' || localStorage.isLogin == 'true' 
                                    
                                    ?
                                    
                                        <div id="chatbox-body" className="chatbox-body" >
                                        {/* <!-- /.direct-chat-messages start --> */}
                                            {this.state.comments.map((comment, index) => {

                                                const months = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

                                                let current_datetime = new Date(comment.created);

                                                let mins = current_datetime.getMinutes();

                                                if(mins < 10){

                                                    mins = '0'+mins;

                                                }
                                                
                                                let formatted_date = months[current_datetime.getMonth()] + " " + current_datetime.getDate() + ", " + current_datetime.getHours() + ":" + mins;

                                                // console.log(comment.name);
                                                
                                                return (
                                                
                                                    <div className="direct-chat-messages"  key={index}>
                                                        <div className="direct-chat-msg">

                                                            <h4 className="direct-chat-name" style={{background:localStorage.commentNameBgColor, color:localStorage.commentNameTextColor}}>{comment.name}</h4>

                                                            <h5 className="direct-chat-timestamp" style={{background:localStorage.commentDateBgColor,color:localStorage.commentDateTextColor}}>{formatted_date}</h5>

                                                            <p style={{background:localStorage.commentTextBgColor, color:localStorage.commentTextColor}}>{comment.comment}</p>
                                                            
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        {/* <!-- /.direct-chat-messages start --> */}

                                        </div>
                                    :
                                        <div className='pt-5 mt-5'>
                                            <p className="qstnDis">{localStorage.loginSubmitQuestionText}</p>
                                        </div>
                                    }
                                    </>
                                :
                                
                                    <div id="chatbox-body" className="chatbox-body" >
                                    {/* <!-- /.direct-chat-messages start --> */}
                                        {this.state.comments.map((comment, index) => {

                                            const months = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

                                            let current_datetime = new Date(comment.created);

                                            let mins = current_datetime.getMinutes();

                                            if(mins < 10){

                                                mins = '0'+mins;

                                            }
                                            
                                            let formatted_date = months[current_datetime.getMonth()] + " " + current_datetime.getDate() + ", " + current_datetime.getHours() + ":" + mins;

                                            console.log(comment.name);
                                            
                                            return (
                                            
                                                <div className="direct-chat-messages"  key={index}>
                                                    <div className="direct-chat-msg">

                                                        <h4 className="direct-chat-name" style={{background:localStorage.commentNameBgColor, color:localStorage.commentNameTextColor}}>{comment.name}</h4>

                                                        <h5 className="direct-chat-timestamp" style={{background:localStorage.commentDateBgColor,color:localStorage.commentDateTextColor}}>{formatted_date}</h5>

                                                        <p style={{background:localStorage.commentTextBgColor, color:localStorage.commentTextColor}}>{comment.comment}</p>
                                                        
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    {/* <!-- /.direct-chat-messages start --> */}

                                    </div>

                                }
                                {this.props.isLogin == 'true' || localStorage.isLogin == 'true'
                                ?
                                    <div className="chatbox-footer">
                                        <form id="comment" onSubmit={(e) =>this.submitComment(e) }>
                                            <input autoComplete="off" onChange={this.setComment}
                                                            value={this.state.inputComment} id="send_comments" type="text" placeholder="Type Message" />
                                            
                                            <a onClick={(e) => this.submitComment(e)} style={{background:localStorage.commentHeaderBgColor, color:localStorage.commentHeaderTextColor, textAlign: 'center', cursor: 'pointer'}}><i className="fas fa-arrow-right"></i></a>
                                        </form>
                                    </div>
                                :
                                    <>
                                    {localStorage.comment_view_with_login == '0' &&
                                        <div className="chatbox-footer">
                                            <p className="qstnDis">{localStorage.loginSubmitQuestionText}</p>
                                        </div>
                                    }
                                    </>
                                }
                            </div>                    
                            :
                            <div className="question-disabled-text">
                                <p className="qstnDis">{localStorage.questionDisabledText}</p>
                            </div>
                        }

                        </div>

                        
                </div>


            </div>
        );
    }

}

export default Comment;
